<template>
  <div class="scores-container">
    <div class="risk-score-card">
      <i class="fa fa-chart-pie risk-icon"></i> Holdings
    </div>

    <table>
      <thead>
        <tr>
          <th>Name (Symbol)</th>
          <th>Quantity</th>
          <th>Cost Basis</th>
          <th>Current Price</th>
          <th>Gain/Loss (%)</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="holding in holdings" :key="holding.id">
          <td data-label="Name (Symbol)">{{ holding.name }} ({{ holding.symbol }})</td>
          <td data-label="Quantity">{{ holding.total_quantity }}</td>
          <td data-label="Cost Basis">${{ holding.cost_basis }}</td>
          <td data-label="Current Price">${{ holding.current_price }}</td>
          <td data-label="Gain/Loss (%)" :class="{'positive-gain': parseFloat(holding.gain_loss_percentage) >= 0, 'negative-loss': parseFloat(holding.gain_loss_percentage) < 0}">
            {{ holding.gain_loss_percentage }}%
          </td>
          <td data-label="Actions">
            <button @click="selectHoldingForUpdate(holding)">Edit</button>
          </td>
        </tr>
      </tbody>
    </table>

    <button @click="showAddHoldingModal">Add Holding</button>

    <div v-if="isAddingHolding" class="modal">
      <div class="modal-content">
        <span class="close" @click="closeAddHoldingModal">&times;</span>
        <h3>Add New Holding</h3>
        <select v-model="newHolding.holding_type">
          <option v-for="(type, index) in holdingTypes" :key="index" :value="type">{{ type.charAt(0).toUpperCase() + type.slice(1) }}</option>
        </select>
        <input type="text" v-model="newHolding.name" placeholder="Name">
        <input type="text" v-model="newHolding.symbol" placeholder="Symbol">
        <input type="number" v-model="newHolding.total_quantity" placeholder="Total Quantity">
        <input type="number" v-model="newHolding.cost_basis" placeholder="Cost Basis">
        <input type="number" v-model="newHolding.current_price" placeholder="Current Price">
        <button @click="addNewHolding">Save</button>
      </div>
    </div>
  </div><br>
</template>

<script>
import { Auth } from 'aws-amplify';

export default {
  data() {
    return {
      holdings: [],
      selectedHolding: null,
      selectedHoldingIndex: null,
      isAddingHolding: false,
      newHolding: {
        name: '',
        symbol: '',
        total_quantity: '',
        cost_basis: '',
        current_price: '',
        holding_type: 'stock',
      },
      holdingTypes: ['stock', 'gic', 'option', 'bond', 'mutual_fund', 'etf', 'futures'],
    };
  },
  methods: {
    async fetchHoldings() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        const response = await fetch('https://api.riskypaws.com/frontoffice/api/holding/', { headers: { 'X-Cognito-Sub': cognitoSub }});
        if (!response.ok) throw new Error('Network response was not ok');
        this.holdings = await response.json();
      } catch (error) {
        console.error('Error fetching holdings:', error);
      }
    },
    selectHoldingForUpdate(holding, index) {
      this.selectedHolding = { ...holding };
      this.selectedHoldingIndex = index;
    },
    async updateHolding() {
      const updateUrl = `https://api.riskypaws.com/frontoffice/api/holding/${this.selectedHolding.id}/`;
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        const response = await fetch(updateUrl, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', 'X-Cognito-Sub': cognitoSub },
          body: JSON.stringify(this.selectedHolding)
        });
        if (!response.ok) throw new Error('Network response was not ok');
        const updatedHolding = await response.json();
        this.holdings.splice(this.selectedHoldingIndex, 1, updatedHolding);
        this.cancelEdit();
      } catch (error) {
        console.error('Error updating holding:', error);
      }
    },
    showAddHoldingModal() {
      this.isAddingHolding = true;
      this.newHolding = {
        name: '',
        symbol: '',
        total_quantity: '',
        cost_basis: '',
        current_price: '',
        holding_type: 'stock',
      };
    },
    closeAddHoldingModal() {
      this.isAddingHolding = false;
    },
    async addNewHolding() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        const response = await fetch('https://api.riskypaws.com/frontoffice/api/holding/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Cognito-Sub': cognitoSub },
          body: JSON.stringify(this.newHolding)
        });
        if (!response.ok) throw new Error('Network response was not ok');
        this.fetchHoldings();
        this.closeAddHoldingModal();
      } catch (error) {
        console.error('Error adding new holding:', error);
      }
    },
    cancelEdit() {
      this.selectedHolding = null;
      this.selectedHoldingIndex = null;
    },
  },
  created() {
    this.fetchHoldings();
  },
};
</script>

      
  <style scoped>

.risk-score-card {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 20px;
  margin-bottom: 20px;
  background-color: #36454f;
  color: white;
  font-size: 24px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-color: #4A148C;
  }
  .scores-container {
    display: flex;
    flex-wrap: wrap; /* Allows items to move to the next row on smaller screens */
    justify-content: center; /* Centers items */
    align-items: center;
    width: 100%;
    border: 2px solid #000;
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
    background-color: white; 
  }

  .edit-btn {
  background: none;
  border: none;
  cursor: pointer;
}

.edit-btn i {
  font-size: 16px;
  color: #4A148C; /* Dark purple */
}

button {
  background-color: #4A148C; /* Purple background */
  color: white; /* White text */
  border: none;
  border-radius: 20px; /* Rounded corners */
  padding: 10px 20px; /* Padding inside the button */
  cursor: pointer; /* Cursor style */
  transition: background-color 0.3s ease; /* Smooth transition for hover effect */
}

button:hover {
  background-color: black; /* Black background on hover */
}


table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #4A148C;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f4f4f4;
}
@media (max-width: 768px) {
  .table-holdings, .table-holdings tbody, .table-holdings tr, .table-holdings td, .table-holdings th {
    display: block;
  }

  .table-holdings thead {
    display: none;
  }

  .table-holdings td {
    position: relative;
    padding-left: 50%;
    margin-bottom: 10px;
    text-align: right;
  }

  .table-holdings td:before {
    content: attr(data-label);
    position: absolute;
    left: 10px;
    width: 45%;
    text-align: left;
    font-weight: bold;
  }

  .table-holdings td[data-label="Actions"] {
    text-align: center;
    padding-left: 0;
  }

  .table-holdings td[data-label="Actions"] button {
    margin: 5px;
  }
}
</style>